import { render, staticRenderFns } from "./InvalidElementsList.vue?vue&type=template&id=40dc8f60&"
import script from "./InvalidElementsList.vue?vue&type=script&lang=js&"
export * from "./InvalidElementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports